import React from "react";
import { Box, Text, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";
import { Item } from "@familyzone/component-library/dist/components/Select";
import SearchableSelect from "../../SearchableSelect";

export interface GenericSingleSelectCriteriaProps {
  criteria: FilteringSourceCriteria;
  namedValue: string;
  options: Item[];
  readableName: string;
  onChange: (criteria: FilteringSourceCriteria) => void;
}

interface OnChange {
  label: string;
  value: string;
}

const GenericSingleSelectCriteria: React.FC<GenericSingleSelectCriteriaProps> = ({ criteria, namedValue, options, onChange }) => {
  const { t } = useTranslation();
  const [existingText, setExistingText] = React.useState<string>("");
  const [existingValue, setExistingValue] = React.useState<string>("");
  const [selectionExists, setSelectionExists] = React.useState<boolean>(true);

  React.useMemo(() => {
    if (criteria?.conditions && !Array.isArray(criteria.conditions)) {
      const conditionValue = criteria.conditions[namedValue];
      const optionText = options.find((o) => o.value === conditionValue)?.text;
      setExistingValue(String(conditionValue));
      setExistingText(optionText ? String(optionText) : String(conditionValue));
      setSelectionExists(options.some((item) => item.value === conditionValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: OnChange) => {
    setExistingValue(event.value);
    onChange({
      ...criteria,
      conditions: { ...criteria.conditions, [namedValue]: event.value },
    });
  };

  const getSelectionMap = () => {
    const ret = [];
    for (const item of options) {
      ret.push([item.value, item.text]);
    }
    return ret;
  };

  return (
    <Box data-testid={namedValue + "-id"}>
      <SearchableSelect
        value={existingValue}
        placeholder="Select"
        onChange={handleChange}
        valueDataMap={getSelectionMap()}
        clearable={false}
      />
      {selectionExists || <Text color="neutrals.400">{t(`Current selection: ${existingText}. Choose another option to change.`)}</Text>}
    </Box>
  );
};

export default GenericSingleSelectCriteria;
